<template>
    <transition name="fade">
        <div class="modal" v-if="config && config.show">
            <div class="modal-overlay">
                <div class="modal-dialog">
                    <div v-if="config.header || $slots['header']" class="modal-header">
                        <slot name="header">
                            <div>
                                {{config.header}}
                            </div>
                        </slot>
                    </div>
                    <div v-if="config.content || $slots['content']" class="modal-content">
                        <slot name="content">
                            {{config.content}}
                        </slot>
                    </div>
                    <div v-if="config.accept || config.reject || config.buttons.length > 0" class="modal-buttons">
                        <template v-for="(button, index) in config.buttons">
                            <button type="button" :key="index" @click="buttonClicked(button)" class="button" :class="{'button-primary': index === 0, 'button-secondary': index !== 0, 'disabled': button.disabled}">{{button.text}}</button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { ModalConfig } from './modal.js'

export default {
    name: 'modal',
    props: {
        config: {
            type: Object,
            default: new ModalConfig({})
        }
    },
    methods: {
        buttonClicked (button) {
            if (typeof button.action === 'string') {
                this.$emit(button.action)
            } else {
                button.action()
            }
            this.config.close()
        }
    }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.modal {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 99999;
    background: rgba(0,0,0,0.2);

    .modal-overlay {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .modal-dialog {
            width: auto;
            height: auto;
            min-width: 800px;
            margin: 0 auto;
            padding: 20px 30px;
            background-color: #fff;
            border-radius: 2px;
            position: relative;
            box-shadow: 0 2px 8px rgba(0,0,0,.33);
            transition: all .3s ease;
            -moz-transition: all .3s ease;
            -o-transition: all .3s ease;
            -webkit-transition: all .3s ease;

            .modal-header {
                margin-top: 10px;
                margin-bottom: 20px;
                text-transform: uppercase;
                font-size: 1.2rem;
                text-align: center;
                font-weight: bold;
            }

            .modal-content {
                // something
            }

            .modal-buttons {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 50px;

                button {
                    margin-left: 5px;
                    margin-right: 5px;
                    border: 0;
                    padding: 9px 27px;
                    border-radius: 4px;
                    min-height: 35px;
                    font-size: 1rem;

                    &:first-of-type {
                        color: #fff;
                    }

                    &.button-secondary {
                        &:hover, &:active, &:focus {
                            background-color: transparent;
                            color: #367ABD;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/modal.vue